module.exports = __webpack_public_path__ + "img/bb_g3_t_eyes-01.649bc0de.svg";